<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import type {FieldTypeId} from 'typings/portaro.be.types';
    import KpRelatedRecordsTable from '../../kp-related-records-table/KpRelatedRecordsTable.svelte';
    import SutorHeading from 'src/features/sutor/pages/record-detail/components/SutorHeading.svelte';
    import {getPageContext} from 'shared/layouts/page-context';

    // Injected from layout builder from BE
    export let fondId: number;
    export let fieldTypeId: FieldTypeId;
    export let tableHeading: string;
    export let hierarchyFieldTypeId: FieldTypeId | null = null;

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

<div class="kp-related-records-table-part" id="related-records-{fondId}-{fieldTypeId}">
    <div class="heading-container">
        <SutorHeading type="h2">{tableHeading}</SutorHeading>
    </div>

    <KpRelatedRecordsTable record="{model.record}" {fondId} {fieldTypeId} {hierarchyFieldTypeId}/>
</div>

<style lang="less">
    .kp-related-records-table-part {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 10px;
        border-radius: 4px;
        outline-offset: 6px;
        outline: 2px solid transparent;
        transition: outline-color 0.3s ease-in-out;

        .heading-container {
            margin-top: 10px;
            margin-left: 2px; // To visually align with the record grid container
        }
    }

    :global {
        .kp-related-records-table-part {
            transition: outline-colo 0.3s ease-in-out;

            &.highlighted-table {
                outline-color: var(--accent-blue-new) !important;
            }
        }
    }
</style>